import { ItiBaseDto } from '@/iti-core-vue';

export class User extends ItiBaseDto {
    public completeUser!: string;
    public email!: string;
    public externalId!: string;
    public businessName!: string;
    public province!: string;
    public address!: string;
    public location!: string;
    public postalCode!: string;
    public country!: string;
    public cif!: string;
    public cnaeCodeId!: number;
    public cnaeCodeDescription!: string;
    public associationId!: number;
    public associationDescription!:string;


    public _id!: number;
    public username!: string;
    public avatar!: string;
    public status!: any;
}
